import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Grid, Group, Paper, Stack, Text } from '@mantine/core';
import { IconSettings, IconTrash } from '@tabler/icons-react';

import { useGetKeywordRules } from '../../api/getKeywordRules';
import { useRemoveKeywordRule } from '../../api/removeKeywordRule';
import { ChunkPlatform } from '../../utils/chunk-limits';
import { AddButton } from '../AddButton';

import { AddModal } from './AddModal';
import { EditModal } from './EditModal';

import { ConfirmModal } from '@/components/Modals/Confirm';
import { COLORS } from '@/utils/colors';

export const KeywordRules = ({ pageId, platform }: { pageId: string; platform: ChunkPlatform }) => {
  const { data, isLoading } = useGetKeywordRules({ pageId });
  const removeKeywordRule = useRemoveKeywordRule({ pageId });
  const rules = data?.rules || [];

  return (
    <>
      <Grid columns={5}>
        {rules.map((rule) => (
          <Grid.Col key={rule._id} span={1}>
            <Paper shadow="md" radius="md" p="md">
              <Group justify="space-between">
                <Stack gap="xs">
                  <Text size="sm">{rule.keyword}</Text>
                </Stack>
                <Group gap="xs">
                  <ActionIcon
                    variant="filled"
                    onClick={() => NiceModal.show(EditModal, { rule, platform })}
                    radius="md"
                    style={{ alignSelf: 'flex-start' }}
                  >
                    <IconSettings color={COLORS.text} />
                  </ActionIcon>
                  <ActionIcon
                    variant="filled"
                    onClick={() =>
                      NiceModal.show(ConfirmModal, {
                        title: `Remove keyword rule (${rule.keyword})?`,
                        onSuccess: () => removeKeywordRule.mutate({ ruleId: rule._id }),
                      })
                    }
                    radius="md"
                    style={{ alignSelf: 'flex-start' }}
                  >
                    <IconTrash color={COLORS.red} />
                  </ActionIcon>
                </Group>
              </Group>
            </Paper>
          </Grid.Col>
        ))}
      </Grid>
      <AddButton
        isLoading={isLoading}
        onClick={() => NiceModal.show(AddModal, { pageId, platform })}
      />
    </>
  );
};
